import client from "./client";

export type ChatServiceRequest = {
  message: string;
  intent?: "CREATE_USER";
  session_id?: string;
};

export const chatService = async (data: ChatServiceRequest) => {
  return client({
    query: `
    mutation ChatService($input: ProcessCustomerQueryInput) {
      process_customer_query(input: $input) {
        message
        session_id
        input_fields {
          name
          label
          options {
            value
            label
          }
        }
      }
    }`,
    variables: {
      input: data
    }
  });
};
